import React from 'react';
import { Box, Flex } from '@leagueplatform/genesis-commons';
import { SkeletonBox } from '@leagueplatform/web-common-components';

export const LeaderboardSkeletonLoader = () => {
  // TODO: think of a better solution for this
  const leaderboardSkeleton = Array(5).fill(0);

  return (
    <Box>
      {leaderboardSkeleton.map((_, index) => (
        <SkeletonBox
          width="100%"
          marginBottom="quarter"
          // using index here as these will be the only thing on the page
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          role="presentation"
        >
          <Flex
            alignItems="center"
            flexDirection="row"
            justifyContent="start"
            paddingTop="oneAndHalf"
            paddingBottom="oneAndHalf"
          >
            <SkeletonBox
              width="twoAndHalf"
              height="twoAndHalf"
              marginInlineStart="four"
              borderRadius="circle"
              // Waiting to hear back from the design team on a new colour / token
              backgroundColor="interactive.background.disabled"
            />
            <SkeletonBox
              marginInlineStart="one"
              width="40%"
              height="oneAndHalf"
              backgroundColor="interactive.background.disabled"
            />
          </Flex>
        </SkeletonBox>
      ))}
    </Box>
  );
};
